<template><v-btn color="primary" @click="inc">
  Klicka här ({{count}})
</v-btn>
</template>
<script>export default {
  data: () => ({
    count: 1
  }),
  methods: {
    inc() {
      this.count++;
    }
  }
}</script>